<div class="inspector-mode-toggle">
  <div class="mode-toggle-header">
    <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
    <span class="toggle-title">{{ 'builderScreen.inspector.modeToggle.title' |translateTA }}</span>
  </div>

  <nz-radio-group 
    [(ngModel)]="currentMode" 
    (ngModelChange)="onModeChange($event)" 
    nzSize="small"
    class="mode-radio-group">
    
    <!-- Floating Mode -->
    <label 
      nz-radio-button 
      [nzValue]="InspectorMode.FLOATING"
      [nz-tooltip]="getModeTooltip(InspectorMode.FLOATING) |translateTA"
      class="mode-option">
      <nz-icon [nzType]="getModeIcon(InspectorMode.FLOATING)" nzTheme="outline"></nz-icon>
      <span class="mode-label">{{ 'builderScreen.inspector.modes.floating' |translateTA }}</span>
    </label>

    <!-- Docked Mode -->
    <label 
      nz-radio-button 
      [nzValue]="InspectorMode.DOCKED_RIGHT"
      [nz-tooltip]="getModeTooltip(InspectorMode.DOCKED_RIGHT) |translateTA"
      class="mode-option">
      <nz-icon [nzType]="getModeIcon(InspectorMode.DOCKED_RIGHT)" nzTheme="outline"></nz-icon>
      <span class="mode-label">{{ 'builderScreen.inspector.modes.docked' |translateTA }}</span>
    </label>

    <!-- Legacy Mode -->
    <label 
      nz-radio-button 
      [nzValue]="InspectorMode.LEGACY_SIDEBAR"
      [nz-tooltip]="getModeTooltip(InspectorMode.LEGACY_SIDEBAR) |translateTA"
      class="mode-option">
      <nz-icon [nzType]="getModeIcon(InspectorMode.LEGACY_SIDEBAR)" nzTheme="outline"></nz-icon>
      <span class="mode-label">{{ 'builderScreen.inspector.modes.legacy' |translateTA }}</span>
    </label>
  </nz-radio-group>

  <!-- Mode Description -->
  <div class="mode-description">
    <ng-container [ngSwitch]="currentMode">
      <p *ngSwitchCase="InspectorMode.FLOATING" class="description-text">
        <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.inspector.modeToggle.floatingDesc' |translateTA }}
      </p>
      <p *ngSwitchCase="InspectorMode.DOCKED_RIGHT" class="description-text">
        <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.inspector.modeToggle.dockedDesc' |translateTA }}
      </p>
      <p *ngSwitchCase="InspectorMode.LEGACY_SIDEBAR" class="description-text">
        <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.inspector.modeToggle.legacyDesc' |translateTA }}
      </p>
    </ng-container>
  </div>
</div>
